<script>
export default {
  emits: ['open'],
  mounted() {},
  methods: {
    openPanel() {
      this.$emit('open');
    },
  },
};
</script>

<template>
  <div
    class="flex text-grey-400 hover:text-grey-900 items-center gap-1 py-2.5 px-1.5 hover:cursor-pointer"
    @click="openPanel()">
    <i class="ga-icon ga-filter" />
    <span class="flex-1 font-inter font-medium text-sm">Tous les filtres</span>
  </div>
</template>
